import { Injectable, signal } from '@angular/core';
import { IUser } from '../interfaces/user.interface';

@Injectable({
  providedIn: 'root'
})

export class CommonService {

  private userDetailSignal = signal<IUser>({ userName: '', name: '' });
  public userDetail: any = this.userDetailSignal.asReadonly();
  
  public isAdminSignal = signal<boolean>(localStorage.getItem('admin') === 'true');
  public isAdmin: any = this.isAdminSignal.asReadonly();

  public isAuthenticatingSignal = signal<any>(false);
  public isAuthenticating: any = this.isAuthenticatingSignal.asReadonly();

  // Signal to control sidenav visibility
  private sidenavVisibleSignal = signal<boolean>(true);
  public sidenavVisible: any = this.sidenavVisibleSignal.asReadonly();

  constructor() { }

  getCurrentuser(): IUser {
    return this.userDetailSignal();
  }
  updateCurrentuser(user: IUser): void {
    this.userDetailSignal.set(user);
  }

  formatDateTime(dateValue: any): string {
    if (!dateValue) return '';

    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return '';

    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    let hours = date.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // Convert 0 to 12

    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
  }

  // Methods to control sidenav visibility
  setSidenavVisible(visible: boolean): void {
    this.sidenavVisibleSignal.set(visible);
  }

  // toggleSidenav(): void {
  //   this.sidenavVisibleSignal.update(visible => !visible);
  // }

}